//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObjectCollection.js";
import "../no/ParamLibParameterLibraryManager.js";
let d=[[],[[["journal_identifier"],"FindObject",{R_:{found:"ParamLibParameter"}},1,0],[[],"CreateListBlockBuilder",{R_:{builder:"ParamLibParameterListBuilder"}},0,0],[["pcLibTypeNeuNames"],"CreateListBlockBuilder1",{R_:{builder:"ParamLibParameterListBuilder"}},1,0],[["parameterTag"],"CreateParameterEditBuilder",{R_:{builder:"ParamLibParameterBuilder"}},1,0],[["parameterTag"],"CreateParameterInspectBuilder",{R_:{builder:"ParamLibParameterBuilder"}},1,0],[["libTypeNeutralName","parameterType"],"CreateParameterBuilder",{R_:{builder:"ParamLibParameterBuilder"}},2,0],[["pcLibTypeNeuNames"],"CreateParameterLibmgrBuilder",{R_:{builder:"ParamLibLibraryManagerBuilder"}},1,0],[["library_name","parameterName"],"LoadFromParamplLibrary",{R_:{parameter:"ParamLibParameter"}},2,0],[["parameterName"],"LoadFromNxparampllibrary",{R_:{parameter:"ParamLibParameter"}},1,0],[["pcLibName","pcParamName"],"GetLoadedLibraryParameter",{R_:{parameter:"ParamLibParameter"}},2,0],[["library_name","library_reference"],"CopyParameterFromLibrary",{R_:{parameter:"ParamLibParameter"}},2,0],[["library_name","library_reference","retain_parent_pedigree"],"CopyParameterFromLibrary1",{R_:{parameter:"ParamLibParameter"}},3,0],[["pcParamNames","pcLibNames","pcExportedLibName"],"OutputParametersToLibrary",{},3,0],[["pcParamNames","pcLibNames","pcExportedLibName","bUpdateLibraryReference"],"ExportParametersToLibrary",{},4,0],[["pcParamNames","pcLibNames","pcExportedLibName","bUpdateLibraryReference"],"ExportParametersToLibrary1",{},4,0],[["tEditedParam","pParamNames","pcLibName"],"UpdateParametersInLibrary",{},3,0],[["pParamNames","pcLibName"],"DeleteParametersFromLibrary",{},2,0],[["pcLibAr","pcParamNameAr"],"InfoLibraryParameter",{},2,0],[["pcLibAr","pcParamNameAr","bOverride","pcFileName"],"InfoLibraryParameterToFile",{},4,0],[["numParameters"],"GetUsedParameters",{R_:{parameters:"ParamLibParameter[]"}},0,0]],[]];
SPLM.ParamLibParameterCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.ParamLibParameterCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;